const state = {
  moresgstate: false,
  joinprice: -1
}
const mutations = {
  change () {
    state.moresgstate = !state.moresgstate
  },
  getjoinprice (state, e) {
    state.joinprice = e
  }
}
export default {
  state,
  mutations
}
